import script from "./AcademyArticle2.vue?vue&type=script&setup=true&lang=js"
export * from "./AcademyArticle2.vue?vue&type=script&setup=true&lang=js"

import "./AcademyArticle2.vue?vue&type=style&index=0&id=76f20dd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76f20dd4"]])

export default __exports__